// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-environment-sticker__square[data-v-a5060652]{background:red;width:100%;height:100%;padding:4px}.v-environment-sticker__label[data-v-a5060652]{font-weight:700;word-break:break-all;font-size:16px;color:#0e1922}", ""]);
// Exports
module.exports = exports;
